export enum AsyncStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export type AsyncData<T> =
  | { status: AsyncStatus.SUCCESS; data: T }
  | { status: AsyncStatus.INITIAL }
  | { status: AsyncStatus.LOADING }
  | { status: AsyncStatus.FAILURE; error?: Error };

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K]
};

export const pickAsyncData = <T, F = T>(asyncData: AsyncData<T>, fallback: F): T | F =>
  asyncData.status === AsyncStatus.SUCCESS ? asyncData.data : fallback;
